import React, { useEffect, useState } from 'react';
import { Button, Space, Typography } from 'antd';

const { Text } = Typography;

const STORAGE_KEY = 'ww_cookie_consent';

type ConsentLevel = 'all' | 'necessary';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const accept = (level: ConsentLevel) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ level, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: '#0f172a',
        border: '1px solid #1e293b',
        borderRadius: 16,
        padding: '20px 28px',
        maxWidth: 680,
        width: 'calc(100vw - 48px)',
        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        gap: 20,
        flexWrap: 'wrap',
      }}
    >
      {/* Cookie icon */}
      <div style={{
        width: 44, height: 44, borderRadius: 12,
        background: 'rgba(253,224,71,0.15)',
        border: '1px solid rgba(253,224,71,0.3)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, fontSize: 22,
      }}>
        🍪
      </div>

      {/* Text */}
      <div style={{ flex: 1, minWidth: 200 }}>
        <Text strong style={{ color: '#f1f5f9', display: 'block', marginBottom: 4, fontSize: 15 }}>
          We use cookies
        </Text>
        <Text style={{ color: '#94a3b8', fontSize: 13, lineHeight: 1.6 }}>
          We use cookies to improve your experience, personalise content, and analyse site traffic.
          By clicking "Accept All" you agree to our{' '}
          <a href="#" style={{ color: '#fde047' }}>Cookie Policy</a>.
        </Text>
      </div>

      {/* Buttons */}
      <Space size={8} style={{ flexShrink: 0 }}>
        <Button
          size="middle"
          onClick={() => accept('necessary')}
          style={{
            background: 'transparent',
            borderColor: '#334155',
            color: '#94a3b8',
            fontWeight: 600,
            borderRadius: 8,
          }}
        >
          Necessary Only
        </Button>
        <Button
          size="middle"
          onClick={() => accept('all')}
          style={{
            background: '#fde047',
            borderColor: '#fde047',
            color: '#0f172a',
            fontWeight: 700,
            borderRadius: 8,
          }}
        >
          Accept All
        </Button>
      </Space>
    </div>
  );
};

export default CookieBanner;
